/**
 * Mensagens de erro em linguagem simples (usuários leigos).
 */
export function friendlyNetworkError(message) {
  const msg = (message || '').toString();
  if (/failed to fetch|networkerror|load failed|network request failed/i.test(msg)) {
    return 'Não foi possível conectar ao servidor. Verifique sua internet (Wi‑Fi ou dados móveis), feche e abra o app ou o navegador e tente de novo. Se o problema continuar, aguarde alguns minutos ou fale com o suporte da instituição.';
  }
  if (/401|não autenticado|sessão/i.test(msg)) {
    return 'Sua sessão expirou. Faça login novamente.';
  }
  if (/403|sem permissão/i.test(msg)) {
    return 'Você não tem permissão para esta ação. Use o perfil correto (candidato, admin, etc.).';
  }
  return msg || 'Ocorreu um erro. Tente novamente.';
}
